// =========================================================
// frontend/js/sidebar-secondary.js - V2.2 (Clean Admin)
// =========================================================

window.renderSecondarySidebar = function() {
    if (window.activeView !== 'settings') return ''; 

    const u = window.currentUser;
    const isOwner = u?.role === 'OWNER' || u?.role === 'ADMIN' || (window.hasPermission && window.hasPermission(window.PERMISSIONS.MANAGE_USERS));

    const menuData = {
        settings: {
            groups: [
                { 
                    label: 'Persönlich', 
                    items: [
                        { id: 'profile', label: 'Profil', icon: 'user' },
                        { id: 'calendar_prefs', label: 'Präferenzen', icon: 'calendar-days' },
                        { id: 'commute', label: 'CO2 & Pendelweg', icon: 'leaf' },
                        { id: 'approvals', label: 'Vorgänge', icon: 'clipboard-check' },
                        { id: 'stats', label: 'Statistiken', icon: 'pie-chart' }
                    ] 
                }
            ]
        }
    };

    if (isOwner) {
        menuData.settings.groups.push({
            label: 'Administration',
            items: [
                { id: 'company', label: 'Unternehmen', icon: 'building-2' },
                { id: 'tree', label: 'Struktur & Ebenen', icon: 'network' },
                { id: 'users', label: 'Mitarbeiter', icon: 'users' },
                { id: 'roles', label: 'Rechte-Matrix', icon: 'shield-check' },
                { id: 'report', label: 'Marketing Impact', icon: 'line-chart' },
                { id: 'status_types', label: 'Status-Arten', icon: 'tags' },
                { id: 'widgets', label: 'Widgets', icon: 'layout-grid' } 
            ]
        });
    }

    return `
        <aside class="w-64 bg-slate-50 dark:bg-slate-900 border-r border-slate-200 dark:border-slate-800 flex flex-col h-screen sticky top-0 py-8 px-6 shrink-0 transition-colors duration-300">
            <h2 class="text-xl font-bold text-slate-800 dark:text-slate-100 mb-8 flex items-center gap-2">
                <i data-lucide="settings" class="w-5 h-5 text-blue-600 dark:text-blue-400"></i> Einstellungen
            </h2>
            
            <div class="flex-1 overflow-y-auto custom-scrollbar">
                ${menuData.settings.groups.map(group => `
                    <div class="mb-8">
                        <p class="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-4 px-2">${group.label}</p>
                        <div class="space-y-1">
                            ${group.items.map(item => `
                                <button onclick="window.activeSubView='${item.id}'; window.render()" 
                                    class="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition-all
                                    ${window.activeSubView === item.id 
                                        ? 'bg-white dark:bg-slate-800 text-blue-600 dark:text-blue-400 shadow-sm border border-slate-100 dark:border-slate-700' 
                                        : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800/50 hover:text-slate-700 dark:hover:text-slate-200'}">
                                    <i data-lucide="${item.icon}" class="w-4 h-4"></i>
                                    ${item.label}
                                </button>
                            `).join('')}
                        </div>
                    </div>
                `).join('')}
            </div>
        </aside>
    `;
};